import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { getSessionToken } from "../../../utils/AuthTokenStore";
import { routeAdmin, routeMaster } from "../../../routes/AuthRoutePath";
import { routePublic } from "../../../routes/PublicRoutePath";

const PublicLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedAccessToken = getSessionToken();
    if (location.pathname !== "/" + routePublic.unauthorizedAccess) {
      if (storedAccessToken) {
        navigate(routeMaster.admin + "/" + routeAdmin.lookup);
      } else if (location.pathname !== "/") {
        navigate(location);
      } else {
        navigate("/" + routePublic.login);
      }
    }
  }, []);

  return <Outlet />;
};

export default PublicLayout;
